import React from "react";

import GlobalUploadStatus from "./GlobalUploadStatus";
import GlobalUploadButton from "./GlobalUploadButton";
import useSampleUpload from "../../hooks/useSampleUpload";
import useExitPrompt from "../../hooks/useExitPrompt";
import { UploadProgress } from "../../components/";
import DragAndDropUpload from "../../components/DragAndDropUpload";

const GlobalUpload = () => {
  const [state, setUploadFiles] = useSampleUpload();
  useExitPrompt(state.uploading);

  const handleUpload = ({
    files,
    password,
    uploadToTicloud,
    rlCloudSandboxPlatform,
    rlCloudSandboxGeolocation,
    rlCloudSandboxLocale,
    rlCloudSandboxInteractive,
    dynamicAnalysis
  }) => {
    if (!files || !files.length) {
      return;
    }
    setUploadFiles({
      files,
      password,
      uploadToTicloud,
      rlCloudSandboxPlatform,
      rlCloudSandboxGeolocation,
      rlCloudSandboxLocale,
      rlCloudSandboxInteractive,
      dynamicAnalysis
    });
  };

  const handleCancel = value => {
    const { controllers } = state || {};
    const controller = controllers[value];
    controller?.abort();
  };

  return (
    <div className="rlbs flex">
      <GlobalUploadStatus uploadStatus={state} />
      <GlobalUploadButton onUpload={handleUpload} />
      <DragAndDropUpload onUpload={handleUpload} />
      {state.status && (
        <UploadProgress
          files={state.status}
          onCancel={handleCancel}
          elementId="upload-progress"
        />
      )}
    </div>
  );
};

export default GlobalUpload;
